export const colors = {
  lightGray: '#f2f2f2',
  darkGray: '#424242',
  lightGrayHover: '#fafafa',
  green: '#4caf50',
  blue: '#4287f5',
  darkBlue: '#3167bd',
  messages: {
    success: '#4caf50',
    warning: '#ff9800',
    error: '#fa6357',
  },
  errorLabel: '#e85656',
  appBar: {
    development: {
      main: '#CD132C',
      selectedNav: '#ffffff',
      unselectedNav: '#CD132C',
    },
    qa: {
      main: '#E8CA45',
      selectedNav: '#ffffff',
      unselectedNav: '#E8CA45',
    },
    production: {
      main: '#f2f2f2',
      selectedNav: '#ffffff',
      unselectedNav: '#f2f2f2',
    },
  },
};
